import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManageUser() {
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function addUser(data) {
    return privateFetch.post(`/v1/admin/user`, data);
  }

  function updateUser(data) {
    return privateFetch.put(`/v1/admin/user/${data?.id}`, data);
  }

  function deleteUser(userID) {
    return privateFetch.delete(`/v1/admin/user/${userID}`);
  }

  function manageUser({ type, ...data } = {}) {
    if (type === 'DELETE') {
      return deleteUser(data.id);
    }

    if (data?.id) {
      return updateUser(data);
    }

    return addUser(data);
  }

  return useMutation(manageUser, {
    onSuccess() {},
    onSettled() {
      queryClient.invalidateQueries('users-lists');
    },
  });
}

export default useManageUser;
